import Filter from './Filter'

export default class NotificationFilter extends Filter {
	constructor (filters) {
		super(filters)

		return this.get('page', null, '?page')
			.get('keyword', null, '&keyword')
			.get('sort', 'value', '&order_by')
			.get('status', null, '&filter_by', this.filterStatus)
			.get('itemsPerPage', null, '&count', this.filterCount)
			.init()
	}

	filterStatus ({ filter, value }) {
		const status = value.replace('In ', '').toLowerCase()

		if (status !== 'all') {
			filter.apiQuery += `&filter_by=${status}`
			filter.routerQuery.status = status
		}

		return filter
	}

	filterCount ({ filter, value }) {
		if (value !== 30) {
			filter.apiQuery += `&count=${value}`
			filter.routerQuery.count = value
		}

		return filter
	}
}
